// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2962":"e45c8bc16623a8cb","4666":"5768916a85319d85","8559":"6d334e2e61dd8a7f"}[chunkId] + ".css";
};